import { useLocation, useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../store/hook';
import { useMemo } from 'react';
import React from 'react';
import { selectLmsLists } from '../store/features/lmsSlice';
import { CourseType, getCourseType } from '../api/utils/lms/utils';

const dashboard = {
  img: '/svg/icon/classHome-gray.svg',
  imgActive: '/svg/icon/classHome-purple.svg',
  title: '클래스 홈',
  path: `./dashboard`,
};
const takeClass = {
  img: '/svg/icon/manageClass-gray.svg',
  imgActive: '/svg/icon/manageClass-purple.svg',
  title: '수업자료 보기',
  path: `./take-class`,
};
const assignment = {
  img: '/svg/icon/todo-gray.svg',
  imgActive: '/svg/icon/todo-purple.svg',
  title: '과제',
  path: `./assignment`,
};
const recitation = {
  img: '/svg/icon/note-gray.svg',
  imgActive: '/svg/icon/note-purple.svg',
  title: 'AI인증제',
  path: `./recitation`,
};
const student = {
  img: '/svg/icon/manageStudent-gray.svg',
  imgActive: '/svg/icon/manageStudent-purple.svg',
  title: '학생 관리',
  path: `./student`,
};

export const getNavigationList = (subType: CourseType) => {
  if (subType === 'HOME') {
    return [dashboard, takeClass, assignment, recitation, student];
  } else if (subType === 'CHURCH') {
    return [dashboard, takeClass, assignment, student];
  } else {
    return [dashboard, takeClass, student];
  }
};

const LmsBottomNavigation = ({ classId }: { classId: string }) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const lmsLists = useAppSelector(selectLmsLists);

  const list = React.useMemo(() => {
    return getNavigationList(getCourseType(classId, lmsLists));
  }, [classId, lmsLists]);

  const path = useMemo(() => {
    const route = location.pathname.split('/');
    if (route.length > 3) {
      const root = route[3]; // ./lms/{classId}/{root}
      if (
        [
          'dashboard',
          'take-class',
          'assignment',
          'recitation',
          'student',
        ].includes(root)
      ) {
        return './' + root;
      }
    }
  }, [location.pathname]);

  const handleNavigation = (_path: string) => {
    if (path === _path) return;

    if (_path === './assignment' || _path === './recitation') {
      _path = _path + '/create';
    }

    navigate(_path);
  };

  return (
    <div
      className={`fixed left-0 z-10 grid h-20 w-full items-center bg-white shadow-card`}
      style={{ gridTemplateColumns: `repeat(${list.length}, 1fr)` }}
    >
      {list.map((navigation, idx) => (
        <div
          className="flex cursor-pointer flex-col items-center"
          onClick={() => handleNavigation(navigation.path)}
          key={idx}
        >
          <img
            src={
              path === navigation.path ? navigation.imgActive : navigation.img
            }
            width={'40px'}
            height={'40px'}
            alt={navigation.title}
          />
          <div
            className={`text-xs font-normal sm:text-sm ${
              path === navigation.path ? 'text-purple5' : 'text-gray7'
            }`}
          >
            {navigation.title}
          </div>
        </div>
      ))}
    </div>
  );
};

export default LmsBottomNavigation;
